import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      maxWidth: 443,
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    header: {
      position: 'relative',
      display: 'flex',
      flexFlow: 'row nowrap',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
    },
    menuWrapper: {
      zIndex: `${theme.zIndex.tooltip + 1} !important`, // overrides inline style provided by Popover
    },
    menuRoot: {
      maxHeight: 386,
    },
    buttonChangeMetric: {
      ...theme.typography.paragraph14,
      color: COLORS.neutral.white,
      textDecoration: 'underline',
      display: 'inline',
      verticalAlign: 'baseline',
    },
    buttonChangeType: {
      ...theme.typography.paragraph14,
      color: COLORS.neutral.white,
      textDecoration: 'underline',
    },
    title: {},
    description: {},
  }),
  { name: 'SectionScoreTooltipContent' }
);
